import styled from 'styled-components';

// header styles
export const WhiteBoldHeader = styled.h1`
    font-family: 'Piers-Bold';
    font-size: 80pt;
    color: white;
`;

export const BlackThinHeader = styled.h1`
    font-family: 'Piers-Regular';
    color: black;
`;

export const GreyBoldSubHeader = styled.h3`
    font-family: 'Piers-Bold';
    color: grey;
`;

// paragraph styles
export const BlackBoldTextLarge = styled.p`
    font-family: 'Piers-Bold';
    font-size: 22pt;
    color: black;
`;

export const BlackBoldTextSmall = styled.p`
    font-family: 'Piers-Bold';
    color: black;
`;

export const BlackThinTextSmall = styled.p`
    font-family: 'Piers-Regular';
    color: black;
`;

export const GreyThinTextSmall = styled.p`
    font-family: 'Piers-Regular';
    color: grey;
`;

export const WhiteThinTextSmall = styled.p`
    font-family: 'Piers-Regular';
    color: white;
`;
